var map = {
	"./addons-modal.tmpl.html": "./src/ng2-app/views/modals/addons-modal.tmpl.html",
	"./agreements-unlimited-gb-modal.tmpl.html": "./src/ng2-app/views/modals/agreements-unlimited-gb-modal.tmpl.html",
	"./cart-clear-confirmation-modal.tmpl.html": "./src/ng2-app/views/modals/cart-clear-confirmation-modal.tmpl.html",
	"./ccds-contact-failure.tmpl.html": "./src/ng2-app/views/modals/ccds-contact-failure.tmpl.html",
	"./ccds-contact-success.tmpl.html": "./src/ng2-app/views/modals/ccds-contact-success.tmpl.html",
	"./confirmation-cart-email.tmpl.html": "./src/ng2-app/views/modals/confirmation-cart-email.tmpl.html",
	"./contact-request-input-virgin-modal.tmpl.html": "./src/ng2-app/views/modals/contact-request-input-virgin-modal.tmpl.html",
	"./contact-request-modal.tmpl.html": "./src/ng2-app/views/modals/contact-request-modal.tmpl.html",
	"./contact-request-virgin-modal.tmpl.html": "./src/ng2-app/views/modals/contact-request-virgin-modal.tmpl.html",
	"./contract-details-modal.tmpl.html": "./src/ng2-app/views/modals/contract-details-modal.tmpl.html",
	"./credit-check-loader.tmpl.html": "./src/ng2-app/views/modals/credit-check-loader.tmpl.html",
	"./data-change-confirmation.tmpl.html": "./src/ng2-app/views/modals/data-change-confirmation.tmpl.html",
	"./drawing-new-numbers.tmpl.html": "./src/ng2-app/views/modals/drawing-new-numbers.tmpl.html",
	"./information-on-limits.tmpl.html": "./src/ng2-app/views/modals/information-on-limits.tmpl.html",
	"./internet-details-modal.tmpl.html": "./src/ng2-app/views/modals/internet-details-modal.tmpl.html",
	"./logout-modal.tmpl.html": "./src/ng2-app/views/modals/logout-modal.tmpl.html",
	"./lottery-number-failure.tmpl.html": "./src/ng2-app/views/modals/lottery-number-failure.tmpl.html",
	"./max-order-value.tmpl.html": "./src/ng2-app/views/modals/max-order-value.tmpl.html",
	"./modal-check-agreements-complete.tmpl.html": "./src/ng2-app/views/modals/modal-check-agreements-complete.tmpl.html",
	"./modal-loader.tmpl.html": "./src/ng2-app/views/modals/modal-loader.tmpl.html",
	"./nip-blacklisted.tmpl.html": "./src/ng2-app/views/modals/nip-blacklisted.tmpl.html",
	"./number-delete-confirmation.tmpl.html": "./src/ng2-app/views/modals/number-delete-confirmation.tmpl.html",
	"./number-verification-failure.tmpl.html": "./src/ng2-app/views/modals/number-verification-failure.tmpl.html",
	"./number-verification-sms-error.tmpl.html": "./src/ng2-app/views/modals/number-verification-sms-error.tmpl.html",
	"./number-verification-sms-sent-again.tmpl.html": "./src/ng2-app/views/modals/number-verification-sms-sent-again.tmpl.html",
	"./number-verification-sms.tmpl.html": "./src/ng2-app/views/modals/number-verification-sms.tmpl.html",
	"./number-verification.tmpl.html": "./src/ng2-app/views/modals/number-verification.tmpl.html",
	"./pos-modal.tmpl.html": "./src/ng2-app/views/modals/pos-modal.tmpl.html",
	"./province-select.tmpl.html": "./src/ng2-app/views/modals/province-select.tmpl.html",
	"./remove-set-confirmation-modal.tmpl.html": "./src/ng2-app/views/modals/remove-set-confirmation-modal.tmpl.html",
	"./show-more-id-type-information.tmpl.html": "./src/ng2-app/views/modals/show-more-id-type-information.tmpl.html",
	"./show-more-m-id-authentication.tmpl.html": "./src/ng2-app/views/modals/show-more-m-id-authentication.tmpl.html",
	"./show-more-online-authentication.tmpl.html": "./src/ng2-app/views/modals/show-more-online-authentication.tmpl.html",
	"./slot-details-modal.tmpl.html": "./src/ng2-app/views/modals/slot-details-modal.tmpl.html",
	"./virgin-ccds-contact-success.tmpl.html": "./src/ng2-app/views/modals/virgin-ccds-contact-success.tmpl.html"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/ng2-app/views/modals sync recursive ^\\.\\/.*\\.tmpl\\.html$";